import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import TextField from "../../../../../../ui/TextField";
import DataSelect from "../../../../../../ui/DataSelect";

import {
  getDictOrganizations,
  getDictWsCategories,
  getSkillsByCategory,
  getDictEduForms,
  getDictTargetGroups,
  getDictMunicipals
} from "../../../../../../Dict/store/actions";

import { loadList as getDictRegions } from "../../../../../../Dict/Region/View/fetch";
import Checkbox from "../../../../../../ui/Checkbox";

const styles = () => ({
  root: {
    "& .MuiFormLabel-root": {
      whiteSpace: "nowrap"
    },
    "& .MuiInputBase-input.Mui-disabled": {
      color: "#000"
    }
  },
  mainGrid:{
    marginTop: 8
  },
});

const defaultData = {
  name: "",
  category: null,
  skill: null,
  municipal: null,
  region: null,
  organization: null,
  targetGroup: null,
  educationForm: null,
  duration: 0,
  published: false,
  stop: false
};

const AddProgramForm = ({ disabled, onFormChange, classes,
                          getDictOrganizations, organizations,
                          getDictWsCategories, categories,
                          getSkillsByCategory, skills,
                          getDictRegions, regions,
                          getDictMunicipals, municipals,
                          getDictEduForms, eduFormList,
                          getDictTargetGroups, targetGroupList}) => {
  const [data, setData] = useState(defaultData);

  useEffect(() => {
    getDictRegions();
    getDictWsCategories();
    getDictTargetGroups();
    getDictEduForms();
  }, [getDictEduForms, getDictRegions, getDictTargetGroups, getDictWsCategories]);

  useEffect(() => {
    if (data && data.region && data.region > -1) {
      let regionId = data.region;
      getDictOrganizations(regionId);
      getDictMunicipals(regionId);
    }
  }, [data, getDictMunicipals, getDictOrganizations]);

  useEffect(() => {
    if (data && data.category && data.category > -1)
      getSkillsByCategory(data.category);
  }, [data, getSkillsByCategory]);


  const onChange = (field, value) => {
    const newState = {
      ...data,
      [field]: value
    };

    setData(newState);
    onFormChange(newState);
  };

  return (
    <div className={classes.root}>
      <TextField
        value={data.name}
        onChange={e => onChange("name", e.target.value)}
        label="Название"
        disabled={disabled}
        required
      />
      {categories &&
      <DataSelect
        value={data.category}
        dataSource={categories}
        label="Направление"
        disabled={disabled}
        onChange={value => onChange("category", value._key)}
        keyField="_key"
      />}
      {skills &&
      <DataSelect
        value={data.skill}
        dataSource={skills}
        label="Компетенция"
        onChange={value => onChange("skill", value._key)}
        disabled={disabled}
        keyField="_key"
      />}
      {regions &&
      <DataSelect
        value={data.region}
        dataSource={regions}
        disabled={disabled}
        onChange={value => onChange("region", value.id)}
        label="Регион"
      />}
      {municipals &&
      <DataSelect
        value={data.municipal}
        dataSource={municipals}
        disabled={disabled}
        onChange={value => onChange("municipal", value._key)}
        label="Город/Поселение"
        required
        keyField="_key"
      />}
      {organizations &&
      <DataSelect
        value={data.organization}
        label="Реализуется партнёром"
        onChange={value => onChange("organization", value._key)}
        dataSource={organizations}
        disabled={disabled}
        required
        keyField="_key"
      />}
      <Grid container spacing={1} className={classes.mainGrid}>
        <Grid item xs={6}>
          {targetGroupList &&
          <DataSelect
            value={data.targetGroup}
            label="Для кого"
            onChange={value => onChange("targetGroup", value._key)}
            dataSource={targetGroupList}
            disabled={disabled}
            keyField="_key"
          />}
        </Grid>
        <Grid item xs={6}>
          {eduFormList &&
          <DataSelect
            value={data.educationForm}
            label="Форма обучения"
            onChange={value => onChange("educationForm", value._key)}
            dataSource={eduFormList}
            disabled={disabled}
            keyField="_key"
          />}
        </Grid>
        <Grid item xs={4}>
          <TextField
            value={data.duration || ""}
            label="Объём"
            disabled={disabled}
            onChange={e => onChange("duration", e.target.value)}
          />
        </Grid>
        <Grid item xs={4}>
          <Checkbox checked={data.published || false}
                    disabled={true}
                    handleChange={(_, val) => onChange("published", val)}
                    label="Опубликована"/>
        </Grid>
        <Grid item xs={4}>
          <Checkbox checked={data.stop || false}
                    disabled={disabled}
                    handleChange={(_, val) => onChange("stop", val)}
                    label="Закрыто для записи"/>
        </Grid>
      </Grid>
    </div>
  );
};

const mapStateToProps = state => ({
  organizations: state.dictAll.organizationList,
  categories: state.dictAll.wsCategoryList,
  skills: state.dictAll.skillList,
  municipals: state.dictAll.municipalList,
  regions: state.dictRegionView.list,
  targetGroupList: state.dictAll.targetGroupList,
  eduFormList: state.dictAll.eduFormList
});

const mapDispatchToProps = dispatch => ({
  getDictOrganizations: (regionId) => dispatch(getDictOrganizations(regionId)),
  getDictWsCategories: () => dispatch(getDictWsCategories()),
  getSkillsByCategory: (categoryId) => dispatch(getSkillsByCategory(categoryId)),
  getDictRegions: () => dispatch(getDictRegions()),
  getDictMunicipals: (regionId) => dispatch(getDictMunicipals(regionId)),
  getDictTargetGroups: () => dispatch(getDictTargetGroups()),
  getDictEduForms: () => dispatch(getDictEduForms()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(AddProgramForm));
